// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { setSessionPolicy } from '@/lib/sessionTimeout';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

/**
 * Compat: chamado pela tela de login (Auth.tsx).
 * Registra a política de sessão (remember vs ephemeral) que é avaliada pelo
 * monitor em src/lib/sessionTimeout.ts.
 */
export const setRememberMe = (value: boolean) => {
  setSessionPolicy(value);
};

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // Tokens em localStorage (necessário para Web Push persistir entre
    // fechamentos do app). Expiração de sessão é enforced no cliente pelo
    // sessionTimeout monitor baseado na flag "remember me".
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    flowType: 'pkce',
  }
});
